module.exports = __webpack_public_path__ + "img/sidebar-3.3a54f533.jpg";